<p-card styleClass="card-container" header="About Me">
  My name is vishwanath as you might have guessed :).i am a Electronics and
  communication engineer by graduation and a sofware Engineer by profession.I
  can talk in Telugu, Tamil , English I am an explorer in all aspects , be it
  Life ,places ,Technology . i always want to know more which motivates me to
  Explore.
</p-card>

<p-card styleClass="card-container" header="Hobbies">
  I have hobbies such as creating skits , playing jokes , reading books
  ,spending time talking about sensible topic I also have hobbies of playing
  sports,be it any.
</p-card>

<p-card styleClass="card-container" header="Fun time">
  Apart from hobbies,my fun time is spending with family.
</p-card>

<p-card styleClass="card-container" header="Friends">
  I am blessed with a pack of good friends all through my life (especially
  school friends) who cares, guides me in required situations.
</p-card>
